//document.addEventListener("DOMContentLoaded", function () {
  var swiper2 = new Swiper(".find-us-in", {
    spaceBetween: 20,
    slidesPerView: 4,
    loop: true,
    autoHeight: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 5000,
    breakpoints: {
      320: {
        slidesPerView: 3,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 20,
      },
      1400: {
        slidesPerView: 10,
        spaceBetween: 20,
      },
    },
  });
  var swiper2 = new Swiper(".as-seen-in", {
    spaceBetween: 20,
    slidesPerView: 4,
    loop: true,
    autoHeight: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 5000,
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1025: {
        slidesPerView: 6,
        spaceBetween: 20,
      },
    },
  });
  var swiper2 = new Swiper(".image-slider", {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 8000,
    allowTouchMove: false,
    centeredSlides: true,
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1025: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    },
  });
  // aaaaqqqq
  // var swiper2 = new Swiper(".related-swiper", {
  //   slidesPerView: 6,
  //   spaceBetween: 5,
  //   loop: true,
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  //   breakpoints: {
  //     // 320: {
  //     //   slidesPerView: 1.5,
  //     // },
  //     // 768: {
  //     //   slidesPerView: 2,
  //     // },
  //     // 1024: {
  //     //   slidesPerView: 5,
  //     // },
  //     320: {
  //       slidesPerView: 4,
  //     },
  //     768:{
  //       slidesPerView: 6,
  //     }
  //   },
  // });

  // PRODUCT SLIDER START
  // Thumb Slider
  const thumbSwiper = new Swiper(".thumbnail-slider", {
    slidesPerView: 3, // Number of thumbnails visible
    spaceBetween: 10, // Space between thumbnails
    watchSlidesProgress: true,
    loop: true,
    freeMode: true,
    breakpoints: {
      320: { slidesPerView: 2 }, // Adjust for smaller screens
      640: { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
    },
  });
  // Main Slider
  const mainSwiper = new Swiper(".main-slider", {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: thumbSwiper, // Link to thumbnail slider
    },
  });
  // PRODUCT SLIDER END

  // FROZEN SLIDER START
  var swiper = new Swiper(".frozen-slider", {
    loop: true,
    spaceBetween: 30,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
  });
  // FROZEN SLIDER CSS END/

  // OUR RANGE SLIDER START
  var swiper2 = new Swiper(".our-range", {
    spaceBetween: 20,
    slidesPerView: 4,
    loop: true,
    autoHeight: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 5000,
    breakpoints: {
      320: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 20,
      },
      1400: {
        slidesPerView: 7,
        spaceBetween: 20,
      },
    },
  });
  // OUR RANGE SLIDER END
//});

// ANNOUNCEMENT BAR SLIDER START
//document.addEventListener("DOMContentLoaded", () => {
  const track = document.querySelector(".announcement-track");
  const items = document.querySelectorAll(".announcement-item");
  const itemCount = items.length;
  const gap = 40;

  for (let i = 0; i < 3; i++) {
    items.forEach((item) => {
      const clone = item.cloneNode(true);
      track.appendChild(clone);
    });
  }

  let totalWidth = 0;
  items.forEach((item) => {
    totalWidth += item.offsetWidth;
  });
  totalWidth += gap * (itemCount - 1);

  const totalItems = track.children.length;
  const totalGaps = gap * (totalItems - 1);
  track.style.width = `${totalWidth * 4 + totalGaps}px`;

  const duration = (totalWidth * 4 + totalGaps) / 100;
  track.style.animationDuration = `${duration}s`;
//});
// ANNOUNCEMENT BAR SLIDER END

// GLOBE MENU LIST POSITION START
document.querySelectorAll(".globeicon").forEach(function(icon) {
  icon.addEventListener("click", function() {
    document.querySelectorAll(".globemenu").forEach(function(menu) {
      if (menu.style.display === "none" || menu.style.display === "") {
        menu.style.display = "block";
      } else {
        menu.style.display = "none";
      }
    });
  });
});
// GLOBE MENU LIST POSITION END

// COLLECTION CARD INDEX NUMBER JS START
//document.addEventListener("DOMContentLoaded", function () {
  const productCards = document.querySelectorAll(".grid__item .product-index");
  productCards.forEach((span, index) => {
    span.textContent = (index + 1).toString().padStart(2, "0");
  });
//});
// COLLECTION CARD INDEX NUMBER JS END

